import { createContext } from "react";

export const FlightListContext = createContext({
  selectedOptions: [] as string[],
  updateFlightList: (_flightListData: any[]) => {},
});
